import { jsx as _jsx } from "react/jsx-runtime";
const NoAuth = () => {
    return (_jsx("div", { children: "Authentication Failed" }));
};
export default NoAuth;
